import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const ProgressBox = styled(Box)({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
